import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import Auth from "@/pages/Auth";
export const Route = createFileRoute("/auth")({ head: ({match}) => pageHead(match.pathname), component: () => (<Auth />) });
